import { AutoMap } from "@automapper/classes";
import { EExpositionClimatique } from "./enums/exposition-climatique";
import { EMeteoType } from "./enums/meteo-type";

export class ZoneSamplingCondition {
    @AutoMap()
    ExpositionClimatique!: EExpositionClimatique;
    @AutoMap()
    VitesseVent?: number;
    @AutoMap()
    Meteo?: EMeteoType;
    @AutoMap()
    Hygrometrie?: number;
    
    public constructor(init?: Partial<ZoneSamplingCondition>) {
        Object.assign(this, init);
    }
}